<template>
  <div>
    <my-header></my-header>

    <div class="system-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="section-container">
        <router-view></router-view>
      </div>

    </div>
  </div>
</template>

<script>
/**
 * @typedef { import('../auth.js').Actor } Actor
 */
import auth from '../auth.js';

import { isRoleAdmin } from '../util.js';

import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'System',

  components: {
    MyHeader,
    SideNav,
  },

  data() {
    return {
      /** @type {?Actor} */
      actor: auth.getViewer(),
    };
  },

  computed: {
    /** @returns {Object[]} */
    menuItems() {
      const thisObj = this;

      const items = [
        {
          title: 'Client min version',
          route: {name: 'system_client_min_version'},
        },
        {
          title: 'Maintenance',
          route: {name: 'system_maintenance'},
        },
        {
          title: 'Level decrements',
          route: {name: 'level_decrements'},
        },
        {
          title: 'Emergency state log',
          route: {name: 'emergency_state_log'},
        },
        {
          title: 'QA users',
          route: {name: 'qa_users'},
        },
        {
          title: 'Players net sessions log conf',
          route: {name: 'system_players_net_sessions_log_conf'},
        },
        {
          title: 'Insider client info',
          route: {name: 'system_insider_client_info'},
        },
      ];

      const isAdmin = isRoleAdmin(this.actor.role);
      if(isAdmin) {
        items.push(
          {
            title: 'Insider server info',
            route: {name: 'system_insider_server_info'},
          },
          {
          title: 'Game server info',
          route: {name: 'system_game_server_info'},
          },
          {
            title: 'Push server info',
            route: {name: 'system_push_server_info'},
          },
          {
            title: 'Redis connection stat',
            route: {name: 'system_redis_connection_stat'},
          },
        );
      }

      items.push(
        {
          title: 'Levels revisions',
          route: {name: 'system_levels_revisions'},
        },
        {
          title: 'Stat',
          route: {name: 'system_stat'},
        },
        {
          title: 'Month payer groups',
          route: {name: 'system_month_payer_groups'},
          isActive() {
            const routeName = thisObj.$route.name;
            return (routeName === 'system_month_payer_groups') || (routeName === 'system_month_payer_group');
          },
        },
        /*
        {
          title: 'Test',
          route: {name: 'system_test'},
        },
        */
      );

      return items;
    },
  },
}
</script>

<style scoped>
.system-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.section-container {
  min-width: 600px;
  padding-top: 1em;
}
</style>
